import React, { useState, useEffect } from 'react';
import DropdownList from '../../components/DropdownList/DropdownList';
import FileUploader from '../../components/FileUploader/FileUploader';
import TextArea from '../../components/TextArea/TextArea';
import RegisterHeader from '../../components/RegisterHeader/RegisterHeader';
import RegisterFooter from '../../components/RegisterFooter/RegisterFooter';
import Popup from '../../components/PopUp/PopUp';
import '../SignUp/ProducerRegistration.css';
import '../multi-lang.css';
import { useDispatch, useSelector } from 'react-redux';
import { setAllChannels, setAllGeners, setAllLanguages, setAllCountries, setProvience, setSelectedData, removeSelectedData, removeAllData } from '../SignUp/ProducerRegistrationSlice';
import { fetchProvienceByCountry, fetchAllCountries, fetchEmail, fetchByfilter } from '../../services/GenericAPI';
import { fetchProducer, updateProducer } from '../../services/api';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import TermsConditions from '../../components/TermsConditions/TermsConditions';
import TitledEditDropdown from '../../components/TitledEditDropdown/TitledEditDropdown';
import { registration } from '../../services/Registration';
import { validatePhoneNumber, validateName, validateWebsite, validateSocialMediaLinks } from '../../util/util';
import { removeAllCheck } from '../../components/TermsConditions/TermsConditionsSlice';
import Toast from "../../components/Toast/Toast";
import ProgressLoader from '../../components/ProgressLoader/ProgressLoader';
import CryptoUtils from '../../util/cryptoUtils';
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';

const EditProducer = () => {
    const { Globals ,languages, setLanguages } = useLanguage();
    const [isLoading, setIsLoading]=useState(false);
    const [formData, setFormData] = useState({
        producerId: '',
        ProducerType: '',
        companyName: '',
        companyRegNo: '',
        title: '',
        name: '',
        email:"",
        countryName:'',
        provinceName:'',
        businessAddress:'',
        countryName:'',
        provinceName:'',
        businessAddress:'',
        website: '',
        socialMediaLinks: [''],
        productionType: '',
        vatRegistrationNumber:"",
        isTaxClearanceCertificate: true,
        isApprovedByAuth: true,
        isTermAndCondition: true,
        taxClearanceCertPin:"",
        isBBBEE:false,
        companyContactNumber:"",
        companyEmail:"",
        declarationOfInfo:"",
        isApproved:true,
        isActive: false,
        languages:[],
        isVendorRegistered:false,
        channels:[],
        genres:[],
        productionTypes:[],
        producerLanguageRefs: [],
        producerChannelRefs: [],
        producerGenreRefs: [],
        producerProductionTypeRefs: [],
        producerFormat:[],
        countryId:'',
        provienceId:'',
        provience:'',
    });
    let countriesList = [];
    const [socialLinks, setSocialLinks] = useState(['']);
    const [title, setTitle] = useState(formData.title || '');
    const [name, setName] = useState(formData.name || '');
    const [phoneNumber, setPhoneNumber] = useState(formData.companyContactNumber || '');
    const [address, setAddress] = useState('');
    const [businessAddress, setBusinessAddress] = useState('');
    const [provience, setProvience] = useState('');
    const [country, setCountry] = useState('');
    const [province, setProvince] = useState('');
    const [website, setWebSite] = useState('');
    const [language, setLanguage] = useState('');
    const [genre, setGenre] = useState([{}]);
    const [channel, setChannel] = useState('');
    const [email, setEmail] = useState('');
    const [isEmailInvalid, setIsEmailInvalid] = useState(false);
    const [isPhoneInValid, setIsPhoneInValid] = useState(false);
    const [isEmailExist, setIsEmailExist] = useState(false);
    const [countSelection, setCountSelection] = useState('');
    const [provincesList, setProvincesList] = useState([]);
    const [provicesDetails, setProvicesDetails] = useState([]);
    const [isRegCanceled, setRegCancel] = useState(false);
    const [isRegSuccess, setRegSuccess] = useState(false);
    const [isRegFailed, setRegFailure] = useState(false);
    const [borderColor, setBorderColor] = useState('');
    const [isNameInvalid, seIsNameInvalid] = useState(false);
    const [isWebsiteInvalid, setIsWebsiteInvalid] = useState(false);
    const [isTitleNotSelected, setTitleNotSelected] = useState(false);
    const [isTouched, setIsTouched] = useState(false);
    const [isSocialMediaInvalid, setIsSocialMediaInvalid] = useState([false]);
    const allChannelsData = useSelector(state => state.producerRegistration.allChannels);
    const allLanguagesData = useSelector(state => state.producerRegistration.allLanguages);
    const allGenersData = useSelector(state => state.producerRegistration.allGeners);
    const allCountriesDetails = useSelector(state => state.producerRegistration.allCountries);
    const allCountriesData = useSelector(state => state.producerRegistration.allCountries.map(ele => ele.countryName));
    const allFormatsData = useSelector(state => state.producerRegistration.allFormats);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isEditSuccess, setEditSuccess] = useState(false);
    const [isEditFailed, setEditFailed] = useState(null); 
    const [isFormEdited, setIsFormEdited] = useState(false);
    const [isEditCanceled, setEditCanceled] = useState(false);
    const [logoFile, setLogoFile]=useState(null);
    const [logoDetails, setLogoDetails]=useState({name:'', downloadPath:'', type:'image/*'});
    const [StoredDocuments, setStoredDocuments]=useState('');
    const location = useLocation();
    const { success,draft } = location.state || {};
    const [successToast, setSuccessToast] = useState(null);
    const [file, setFile]=useState(null);
    useEffect(() => {
        if (isEditSuccess) {
            setSuccessToast({status: true, title: "Profile updated successfully!"});
            setEditSuccess(false);
        }
    }, [isEditSuccess]);

    const fetchProducerData = async () => {
        try {
            const data = await fetchProducer();
            const documents = data?.content?.documents;
            setStoredDocuments(documents);
             //Logo
             const logoFileName = documents?.find(file => file?.documentFor === 'PLOGO')?.documentName;
             const logoFileDPath = documents?.find(file => file?.documentFor === 'PLOGO')?.documentPath;
             setLogoDetails({ name: logoFileName, downloadPath: logoFileDPath });

            const producer = data.content.producer;
            let socialMediaArray = producer.socialMediaLinks
            ? producer.socialMediaLinks.split(',')
            : [];
        if (socialMediaArray.length === 0) {
            socialMediaArray = [''];
        }
        setSocialLinks(socialMediaArray);
        setIsSocialMediaInvalid(socialMediaArray.map(()=> false));
        setSocialLinks(socialMediaArray); 
            setFormData({
                producerId: producer?.producerId || "",
                companyName: producer?.companyName || "",
                companyRegNo: producer?.companyRegNo || "",
                title: producer?.title || "",
                provinceId: producer?.provinceId,
                provinceName: producer?.provinceName,
                countryId: producer?.countryId || producer?.regionId,
                countryName: producer?.countryName,
                name: producer?.name || "",
                email: producer?.email || "",
                website: producer?.website || "",
                productionType: producer?.productionType || "",
                companyContactNumber: producer?.companyContactNumber || "",
                businessAddress: producer?.businessAddress || "",
                companyEmail: producer?.companyEmail || "",
                vatRegistrationNumber: producer?.vatRegistrationNumber || "",
                isBBBEE: producer?.isBBBEE || false,
                producer: producer?.producer || '',
                languages: data?.content?.languages,
                productionTypes: data?.content?.productionTypes,
                genres: data?.content?.genres,
                genre: data?.content?.genre,
                channels: data?.content?.channels,
                producerLanguageRefs: [],
                producerChannelRefs: [],
                producerGenreRefs: [],
                producerProductionTypeRefs: [],
                producerFormat: [],
            });
        } catch (error) {
            console.error('Error fetching producer data:', error);
        }
    }
    useEffect(() => {
        fetchProducerData();
    }, []); 

    const handleInputChange = (e) => {
        const { value } = e.target;
        setFormData(prevFormData => ({ 
            ...prevFormData,
            value
        }));
        setIsFormEdited(true);
    };

    useEffect(() => {
    }, [socialLinks, formData]);

    const handleSocialMedia = (index, link) => {
        const newSocialLinks = [...socialLinks];
        newSocialLinks[index] = link;
        setSocialLinks(newSocialLinks);

        const socialLinksString = newSocialLinks.join(',');

        setFormData(prevFormData => ({
            ...prevFormData,
            socialMediaLinks: socialLinksString,
        }));

        checkSocialMedia(index, link);
    };

    const addSocialLink = () => {
        const newSocialLinks = [...socialLinks, ''];
        setSocialLinks(newSocialLinks);

        const socialLinksString = newSocialLinks.join(',');

        setFormData(prevFormData => ({
            ...prevFormData,
            socialMediaLinks: socialLinksString,
        }));
    };

    const removeSocialLink = (index) => {
        const updatedLinks = socialLinks.filter((_, i) => i !== index);
        setSocialLinks(updatedLinks);

        const updatedInvalidState = [...isSocialMediaInvalid];
        updatedInvalidState.splice(index, 1);
        setIsSocialMediaInvalid(updatedInvalidState);

        const socialLinksString = updatedLinks.join(',');

        setFormData(prevFormData => ({
            ...prevFormData,
            socialMediaLinks: socialLinksString,
        }));
    };

    const checkSocialMedia = (index, link) => {
        if (link) {
            const isValid = validateSocialMediaLinks(link);
            const updatedInvalidState = [...isSocialMediaInvalid];
            updatedInvalidState[index] = !isValid;
            setIsSocialMediaInvalid(updatedInvalidState);
        } else {
            const updatedInvalidState = [...isSocialMediaInvalid];
            updatedInvalidState[index] = false;
            setIsSocialMediaInvalid(updatedInvalidState);
        }
    };

    useEffect(() => {
        if (allLanguagesData || allLanguagesData.length === 0) {
            fetchByfilter("Languages").then((response) => {
                dispatch(setAllLanguages({ allLanguages: response.data.content["Languages"] }));
            })
        }
        if (allGenersData || allGenersData.length === 0) {
            fetchByfilter("Genres").then((response) => {
                dispatch(setAllGeners({ allGeners: response.data.content["Genres"] }));
            })
        }
        if (allChannelsData || allChannelsData.length === 0) {
            fetchByfilter("Channels").then((response) => {
                dispatch(setAllChannels({ allChannels: response.data.content["Channels"] }));
            })
        }
        if (allCountriesData || allCountriesData.length === 0) {
            fetchAllCountries().then((response) => {
                dispatch(setAllCountries({ allCountries: response.data.content }));
                countriesList = response.data.content.map(country => country.countryName)
            }).catch((error) => {
                console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
            });
        }
    }, []);

    const handleTitleSelection = (event) => {
        setTitleNotSelected(false);
        setTitle(event);
        setBorderColor('#0B0C0C');
        setFormData((prevFormData) => ({
          ...prevFormData,
          title: event,
        }));
      };
      
      useEffect(() => {
        if (formData.title) {
          setTitle(formData.title);
        }
      }, [formData.title]);


      const handleUserNameChange = (event) => {
        const newName = event.target.value;
        checkTitle();
        setName(newName);
        setBorderColor('#0B0C0C');
        setFormData((prevFormData) => ({
          ...prevFormData,
          name: newName,
        }));
        if(newName) {
            const isValid = validateName(newName);
            isValid ? seIsNameInvalid(false) : seIsNameInvalid(true);
        }
      };

      useEffect(() => {
        if (formData.name) {
          setName(formData.name);
        }
      }, [formData.name]);

    const [formDataS, setFormDataS] = useState({ language: [] });
    const [genres, setgenres] = useState({ genres:[]});
    const [channelS, setchannelS] = useState({channels: []});

    const [isConfirmUpdatePopupVisible, setIsConfirmUpdatePopupVisible] = useState(false);



    const handleUpdate = async () => {
        const socialMediaString = socialLinks.join(',');
        const formDataToSend = {"producer":{
            ...formData,
            language: formData.languages,
            genre: formData.genres,
            provience: formData.provinceId,
            country: formData.countryId,
            socialMediaLinks: socialMediaString,
            countryName:formData.countryName,
            provinceName:formData.provinceName,
            producerType: FallBackLabel.SIGNUP.TYPE.INDIVIDUAL,
        }
        };
          delete formDataToSend.languages;
          delete formDataToSend.genres;
          if (logoFile) {
            setEditSuccess(true);
            if (logoFile) {
                formDataToSend.logoFile = logoFile;
            }
        } else {
            setEditSuccess(false);
            formDataToSend.documents = StoredDocuments;
        }

       //new object structure
        const requestObj = {
            producerId: formData.producerId,
            logofile: logoFile || logoDetails,
            producerType: FallBackLabel.SIGNUP.TYPE.INDIVIDUAL,
            title: formData.title,
            name: formData.name,
            email: formData.email,
            businessAddress: formData.businessAddress,
            companyContactNumber: formData.companyContactNumber,
            language: formData.languages,
            genre: formData.genres,
            channels: formData.channels,
            website: formData.website,
            socialMediaLinks: formData.socialMediaLinks,
            country: formData.countryId,
            provience: formData.provinceId,
            documents:StoredDocuments
        }
        try {
            const apiResponse = await updateProducer(requestObj);
            setIsLoading(false);
            if (apiResponse && apiResponse.status === 'OK') {
                setFormData(prevFormData => ({
                    ...prevFormData,
                }));
                setEditSuccess(true);
                setEditFailed(null);
                CryptoUtils.saveToLocalStorage('fullName',formData.name);
                return true; 
            } else {
                console.error("API returned an error:", apiResponse);
                setEditFailed(apiResponse?.message || "Failed to update producer.");
                setEditSuccess(false);
                return false; 
            }
        } catch (error) {
            setIsLoading(false);
            console.error("Error updating producer (network or other):", error);
            setEditFailed("A network or unexpected error occurred.");
            setEditSuccess(false);
            return false;
        }
    };
        const handleUpdateOrConfirm = () => {
            setIsConfirmUpdatePopupVisible(true);
        };
        
        const navigateToProducerProfile = () => {
            navigate('/producerProfile?updatedSucessfully=true');
        };
        
        const confirmUpdateAndCallApi = async () => {
            setIsLoading(true);
            setIsConfirmUpdatePopupVisible(false);
            const updateSuccess = await handleUpdate();
            if (updateSuccess) {
                navigate('/producerProfile?updatedSuccessfully=true');
            } else {
            setEditFailed(true)
            }
        };


    const handleCancelEdit = () => {
        setEditCanceled(true);
    };

    const handlePhoneNumberChange = (event) => {
        const phNumber = event.target.value.replace(/[^0-9+]/g, '');
        setIsPhoneInValid(false);
        const res = validatePhoneNumber(phNumber);
        setPhoneNumber(phNumber);
        setIsPhoneInValid(!res);
        setBorderColor('#0B0C0C');
        setFormData((prevFormData) => ({
          ...prevFormData,
          companyContactNumber: phNumber,
        }));
      };
      useEffect(() => {
        if (formData.companyContactNumber) {
          setPhoneNumber(formData.companyContactNumber.trim());
        }
      }, [formData.companyContactNumber]);

    const handleProvince = (selectedProvinceName) => {
        const provinceId = provicesDetails.find(item => item.provinceName === selectedProvinceName)?.provinceId;
    
        if (provinceId) {
            setFormData(prevFormData => ({
                ...prevFormData,
                provinceId: provinceId,
                provinceName: selectedProvinceName,
            }));
            setBorderColor('#0B0C0C');
        } else {
            console.error("Province not found:", selectedProvinceName);
        }
    };
    
    const handleCountry = (selectedCountryName) => {
        const selectedCountry = allCountriesDetails.find(item => item.countryName === selectedCountryName);
        if (selectedCountry) {
            const countryId = selectedCountry.countryId;
            setFormData({
                ...formData,
                countryId: countryId,
                countryName: selectedCountryName,
                provinceId: null,
                provinceName: null,
            });
            setProvicesDetails([]);
            setProvincesList([]);

            fetchProvienceByCountry(allCountriesDetails, selectedCountryName)
                .then((response) => {
                    const provinces = response.data.content;
                    setProvicesDetails(provinces);
                    setProvincesList(provinces.map(prov => prov.provinceName));
                    dispatch(setProvince({ province: provinces.map(prov => prov.provinceName) }));
                })
                .catch((error) => {
                    console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
                });
        } else {
            console.error("Country not found:", selectedCountryName);
        }
    };
            useEffect(() => {
            if (formData.countryName) {
            fetchProvienceByCountry(allCountriesDetails, formData.countryName)
            .then((response) => {
            const provinces = response.data.content;
            setProvicesDetails(provinces);
            setProvincesList(provinces.map(prov => prov.provinceName));
            dispatch(setProvince({ province: provinces.map(prov => prov.provinceName) }));
            })
            .catch((error) => {
            console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
            });
        }
    }, [formData.countryId, allCountriesDetails, dispatch]);

      const handleWebsiteChange = (e, fieldName) => {
        setFormData({
            ...formData,
            [fieldName]: e.target.value,
        });
    
        if (fieldName === 'website') {
            const isValidUrl = (urlString) => {
                try {
                    return Boolean(new URL(urlString));
                } catch (e) {
                    return false;
                }
            };
    
            if (e.target.value.trim() !== "" && !isValidUrl(e.target.value)) {
                setIsWebsiteInvalid(true);
            } else {
                setIsWebsiteInvalid(false);
            }
        }
    };

    const checkForEmail = () => {
        setIsTouched(true);
        setIsEmailInvalid(false);
        setIsEmailExist(false);
        if (email.length === 0) {
            setIsEmailInvalid(false);
            setIsEmailExist(false);
        }
        else {
            const regex = Globals.REGEX.EMAIL_REGEX;
            const isValid = regex.test(email);
            if (isValid) {
                fetchEmail(email).then((response) => {
                    response.data.exists ? setIsEmailExist(true) : setIsEmailExist(false);
                }).catch((error) => { console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error) })
            }
            else {
                setIsEmailInvalid(!isValid);
            }
        }
    }

    const checkName = () => {
        const isValid = validateName(name);
        isValid ? seIsNameInvalid(false) : seIsNameInvalid(true);
    }

    const checkTitle = () => {
        title.trim() === "" ? setTitleNotSelected(true) : setTitleNotSelected(false);
    }

    const checkForEmptyNumber = () => {
        if(phoneNumber.trim() === "" ){ 
            setIsPhoneInValid(true) 
        }
        else{
            const res = validatePhoneNumber(phoneNumber);
            setIsPhoneInValid(!res);
        }
    }

      const handleSelectedChannelsValues = (selectedChannelObjects) => {
        if (!Array.isArray(selectedChannelObjects)) {
            console.error("selectedChannelObjects is not an array:", selectedChannelObjects);
            return;
        }
        const updatedChannels = selectedChannelObjects.map(channel => ({
            channelId: channel.id,
            channelName: channel.name
        }));
        setFormData((prevFormData) => ({ ...prevFormData, channels: updatedChannels }));
    };

    const handleSelectAllChannels = (e) => {
        if (e) {
            setFormData((prevFormData) => ({...prevFormData, channels: allChannelsData.map(item => ({channelId: item.id, channelName: item.name}))}));
        } else {
            setFormData((prevFormData) => ({...prevFormData, channels: []}));
        }
    };
    const selectChannels = allChannelsData.filter((channel) => {
        if (formData.channels && Array.isArray(formData.channels)) {
            return formData.channels.some((response) => response.channelId === channel.id);
        } else {
            return false;
        }
    });
    const handleGenreValues = (selectedGenreObjects) => {
        if (!Array.isArray(selectedGenreObjects)) {
            console.error("selectedGenreObjects is not an array:", selectedGenreObjects);
            return;
        }
        const updatedGenres = selectedGenreObjects.map(genre => ({
            genreId: genre.id,
            genreName: genre.name,
        }));
        setFormData((prevFormData) => ({ ...prevFormData, genres: updatedGenres }));
    };
    
    const selectGenres = allGenersData.filter((genre) => {
        if (formData.genres && Array.isArray(formData.genres)) {
            return formData.genres.some((response) => response.genreId === genre.id);
        } else {
            return false;
        }
    });
    
    const handleSelectAllGenres = (e) => {
        if (e) {
            setFormData((prevFormData) => ({ ...prevFormData, genres: allGenersData.map(item => ({ genreId: item.id, genreName: item.name })) }));
        } else {
            setFormData((prevFormData) => ({ ...prevFormData, genres: [] }));
        }
    };
    
    const handleSelectedLanguageValues = (selectedLanguageObjects) => {
        if (!Array.isArray(selectedLanguageObjects)) {
            return;
        }
        const updatedLanguages = selectedLanguageObjects.map(language => ({
            languageId: language.id,
            languageName: language.name,
        }));
        setFormData((prevFormData) => ({ ...prevFormData, languages: updatedLanguages }));
    };
    
    const handleSelectAllLanguages = (e) => {
        if (e) {
            setFormData((prevFormData) => ({ ...prevFormData, languages: allLanguagesData.map(item => ({ languageId: item.id, languageName: item.name })) }));
        } else {
            setFormData((prevFormData) => ({ ...prevFormData, languages: [] }));
        }
    };
    
    const selectLang = allLanguagesData.filter((language) => {
        if (formData.languages && Array.isArray(formData.languages)) {
            return formData.languages.some((response) => response.languageId === language.id);
        } else {
            return false;
        }
    });

    useEffect(() => {
    }, [socialLinks, formData]);

    const handleLogoFileInput=(file)=>{
        setLogoFile(file);
    }
        const handleFileRemove = (fileType) => {
            if (fileType === 'logo') {
                setLogoFile(null);
                setStoredDocuments(prevDocuments =>
                    prevDocuments.filter(doc => doc.documentFor !== 'PLOGO')
                );
            }
        };
    
    const isFormValid =   title.trim() !== '' && name.trim() !== '' && phoneNumber.trim() !== '' && !isPhoneInValid 
    return (
        <div id="register-container-edit" className="register-container-edit">
            <RegisterHeader onCancelRegister={handleCancelEdit} title={Globals.SIGNUP.EDIT_PRODUCER} />
            <div id="register-form-edit" className="register-form-edit">
                <div id="register-form-content-edit" className="register-form-content-edit">
                    <h3 id="basic-info" className="basic-info-edit">{Globals.SIGNUP.BASIC_INFO}</h3>
                    <div id="row-content" className="row-1-content-edit">
                    <div id="title-holder">
                            <label id="user-title-edit" className="user-title-edit">{Globals.SIGNUP.TITLE}<span id="mandatory-edit" className="mandatory-edit">{Globals.MANDATORY_FIELD}</span></label>
                            <span tabIndex={1} onBlur={checkTitle}><DropdownList options={Globals.SIGNUP.TITLES_LIST} placeHolderValue={Globals.SIGNUP.TITLES_INP_PLACEHOLDER} onSelect={handleTitleSelection} selectClass={title && "hightlight-edit"} selectedValues={title} /></span>
                            {isTitleNotSelected && (<div><img id="login-error-edit" className="login-error-edit" src={Globals.IMG.ERROR} alt="password error"/>
                    <label className="invalidCredential">{Globals.ERROR_MESSAGES.UNSELECTED_TITLE}</label></div> )}
                    </div>
                        <div id="name-holder-edit">
                            <label id="name-edit">{Globals.SIGNUP.NAME}<span id="mandatory-edit" className="mandatory-edit">{Globals.MANDATORY_FIELD}</span></label>
                            <input type="text" id="name-inp-edit" className={`name-inp ${name && name.length > 0 ? "hightlight-edit" : ""}`} placeholder={Globals.SIGNUP.NAME_INP_PLACEHOLDER} onChange={handleUserNameChange} tabIndex={2} maxLength={30} value={name} onBlur={checkName} autoComplete='off'></input>
                        {isNameInvalid && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{name.trim().length === 0 ? Globals.ERROR_MESSAGES.EMPTY_NAME : Globals.ERROR_MESSAGES.INVALID_NAME}</label></div>}
                    </div>
                        <div id="email-holder-edit">
                            <label id="email-edit">{Globals.SIGNUP.EMAIL}<span id="mandatory-edit" className="mandatory-edit">{Globals.MANDATORY_FIELD}</span></label>
                            <input id="website-inp-edit hightlight-edit" className='company-default-edit' placeholder={Globals.SIGNUP.EMAIL_INP_PLACEHOLDER} onChange={handleInputChange} onBlur={checkForEmail} tabIndex={3} value={formData.email} disabled={true} autoComplete='off'></input>
                        </div>
                        <div id="phone-number-holder-edit">
                            <label id="phone-number-edit">{Globals.SIGNUP.PHONE_NUMBER}<span id="mandatory-edit" className="mandatory-edit">{Globals.MANDATORY_FIELD}</span></label>
                            <input type="tel" pattern="[0-9+]+" id="phone-number-inp-edit" className={`phone-number-inp-edit ${phoneNumber && phoneNumber.length > 0 ? "hightlight-edit": ""}`} placeholder={Globals.SIGNUP.PHONE_NUMBER_INP_PLACEHOLDER} onChange={handlePhoneNumberChange} onBlur={checkForEmptyNumber} tabIndex={4} value={phoneNumber} autoComplete='off' ></input>
                            {isPhoneInValid && (
                        <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="phone number error"/>
                    <label className="invalidCredential">{phoneNumber.length > 0 ? Globals.ERROR_MESSAGES.INVALID_PHONE_NUMBER: Globals.ERROR_MESSAGES.EMPTY_PHONE_NUMBER}</label></div>)}
                    </div>
                    </div>
                    <div id="row-content-edit" className="row-1-content-edit">
                        <div id="logo-pic-holder-edit">
                            <label id="logo-pic" className="logo-pic-edit">{Globals.SIGNUP.LOGO_PIC}</label>
                            <span tabIndex={5}><FileUploader onFileUpload={(file)=>handleLogoFileInput(file)} supportedFileType="ImagesOnly" isPreloadedFile={logoDetails?.name?true:false} preDefinedFile={logoDetails} isFromRegPage={true} onFileRemove={() => handleFileRemove('logo')} isLogoHolder={true}/></span>
                        </div>
                        <div id="physical-address-holder-edit">
    <label id="physical-address-edit" className="physical-address-edit">{Globals.SIGNUP.PHYSICAL_ADDRESS}</label>
    <span tabIndex={6}>
        <TextArea
            id="addressTextArea"
            placeHolder={Globals.SIGNUP.ADDRESS_PLACEHOLDER}
            value={formData.businessAddress}
            textAreaInput={(value) => setFormData({ ...formData, businessAddress: value })}
            className={formData.businessAddress && formData.businessAddress.length > 0 ? "hightlight-edit" : ""}
        />
    </span>
</div>
                        <div id="country-holder-edit">
                            <label id="country-edit" className="country-edit">{Globals.SIGNUP.COUNTRY}</label>
                            <span tabIndex={7}><DropdownList options={allCountriesData} placeHolderValue={Globals.SIGNUP.COUNTRY_PLACEHOLDER} onSelect={handleCountry} selectClass={country && "hightlight-edit"} selectedValues={formData.countryName} /></span>
                        </div>
                        <div id="provience-holder-edit">
                            <label id="provience-edit" className="provience-edit">{Globals.SIGNUP.PROVIENCE}</label>
                            <span tabIndex={8}><DropdownList options={provincesList} placeHolderValue={Globals.SIGNUP.PROVIENCE_PLACEHOLDER} onSelect={handleProvince} selectClass={provience && "hightlight-edit"} selectedValues={formData.provinceName} /></span>
                        </div>
                    </div>
                   <div id='website-holder-edit'>
                       <label id="website-edit" className="website-edit">{Globals.SIGNUP.WEBSITE}</label>
                       <input
                           type='url'
                           id="website-inp-edit"
                           className={`website-inp-edit ${formData.website && formData.website.trim() !== "" ? "highlight-edit-web" : ""}`}
                           placeholder={Globals.SIGNUP.WEBSITE_PLACEHOLDER}
                           onChange={(e) => handleWebsiteChange(e, 'website')}
                           tabIndex={9}
                           value={formData.website}
                       />
                   </div>
                    <div id="row-content" className="row-1-content-edit">
                    <div id="social-media-holder-edit">
    <label id="social-media" className="social-media-edit">{Globals.SIGNUP.SOCIAL_MEDIA}</label>
    {socialLinks.map((link, index) => (
        <div className="reg-social-media-default-inp-edit" style={{ display: 'flex' }} key={index}>
            <div id="social-media-section-edit" className="social-media-section-edit">
                <input
                    type='url'
                    key={`social-link-${index}`}
                    value={socialLinks[index] || ''} 
                    id="social-media-inp-edit"
                    className={`social-media-inp-edit ${socialLinks[index] && socialLinks[index].length > 0 ? "hightlight-edit" : ""}`}
                    placeholder={Globals.SIGNUP.SOCIAL_MEDIA_PLACEHOLDER}
                    onChange={(event) => handleSocialMedia(index, event.target.value)} 
                />
            </div>
            {index > 0 && (
                <button
                    type="button"
                    className="remove-social-link-edit"
                    onClick={() => removeSocialLink(index)}
                />
            )}
        </div>
    ))}
    {socialLinks.length < 3 ? (
        <button
            type="button"
            id="reg-comp-add-social-link-edit"
            className={`${localStorage.getItem('lang')!=='en' ?"add-more-links":"reg-comp-add-social-link-edit"}`}
            onClick={addSocialLink}
        >
            {Globals.SIGNUP.ADD_MORE_LINKS}
        </button>
    ) : (
        <button
            type="button"
            id="reg-add-social-link-disabled-edit"
            className="reg-add-social-link-disabled-edit"
            disabled={true}
        >
            {Globals.SIGNUP.ADD_MORE_LINKS}
        </button>
    )}
</div>
                    </div>
                    <div id="row-content" className="row-1-content-edit">
                    <div id="language-holder-edit">
    <label id="language-edit" className="language-edit">{Globals.SIGNUP.LANGUAGE}</label>
    <span tabIndex={9}>
        <TitledEditDropdown
            title={Globals.SIGNUP.LANGUAGE_PLACEHOLDER}
            options={allLanguagesData}
            onSelectAll={handleSelectAllLanguages}
            onSelect={handleSelectedLanguageValues}
            selectedValues={selectLang}
            selectClass={selectLang.length > 0 ? "hightlight-edit" : ""}
        />
    </span>
</div>
    <div id="genre-holder">
    <label id="genre-edit" className="genre-edit">{Globals.SIGNUP.GENRE}</label>
    <span tabIndex={8}>
        <TitledEditDropdown
            title={Globals.SIGNUP.GENRE_PLACEHOLDER}
            options={allGenersData}
            onSelectAll={handleSelectAllGenres}
            onSelect={handleGenreValues}
            selectedValues={selectGenres}
            selectClass={selectGenres.length > 0 ? "hightlight-edit" : ""}
        />
    </span>
</div>
        <div id="channels-holder-edit">
        <label id="channels-edit" className="channels-edit">{Globals.SIGNUP.CHANNELS}</label>
        <span tabIndex={12}>
        <TitledEditDropdown
            title={Globals.SIGNUP.CHANNELS_PLACEHOLDER}
            options={allChannelsData}
            onSelectAll={handleSelectAllChannels}
            onSelect={handleSelectedChannelsValues}
            selectedValues={selectChannels}
            selectClass={selectChannels.length > 0 ? "hightlight-edit" : ""}
        />
    </span>
    </div>
                    </div>
                    <div className="seperator-edit"></div>
                </div>
            </div>
            <div>
            </div>
            <div>
            <span>

    <RegisterFooter
    onSubmit={handleUpdateOrConfirm}
    onCancelRegister={handleCancelEdit}
    isButtonEnabled={isFormValid}
    tabIndex1={26}
    tabIndex2={27}
/>
</span></div>
{isEditCanceled && (
    <div className='popup-bg'>
        <Popup
            title={Globals.ABORT_UPDATE_PROFILE}
            text={Globals.EDIT_PROFILE.POPUP.cancel.MESSAGE}
            negativeAction={navigateToProducerProfile}
            negativeActionText={Globals.ABORT_UPDATE_PROFILE}
            onClose={() => setEditCanceled(false)}
            popupType={"abort"}
        />
    </div>
)}

{isEditFailed && (
    <div className='popup-bg'>
        <Popup
            title={Globals.PROFILE_UPDATE_ERROR_POPUP_TITLE}
            text={Globals.PROFILE_UPDATE_ERROR_POPUP_TEXT}
            normalAction={handleUpdate}
            normalActionText={Globals.EDIT_PROFILE.POPUP.retry.BUTTON_TEXT}
            popupType={"failed"}
            onClose={() => setEditFailed(null)}
        />
    </div>
)}

{isConfirmUpdatePopupVisible && (
    <div className='popup-bg'>
        <Popup
            title= {Globals.EDIT_PROFILE.POPUP.Update.BUTTON_TEXT}
            text={Globals.PROFILE_UPDATE_CONFIRMATION}
            normalAction={confirmUpdateAndCallApi}
            normalActionText={Globals.EDIT_PROFILE.POPUP.Update.BUTTON_TEXT}
            onClose={() => setIsConfirmUpdatePopupVisible(false)}
            popupType="confirm"
        />
    </div>
    
)}
{isLoading&&<ProgressLoader height={"50"} width={"50"} component={"edit"}/>}

        </div>
    )
}
export default EditProducer;